import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SideBarMenu } from '../../models/side-bar-menu.model';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
	@Input() sideBarMenus: SideBarMenu[] = [];
	@Output() itemInSide: EventEmitter<any> = new EventEmitter();
	@Output() javaSiteUrl: EventEmitter<string> = new EventEmitter();
	finalMenu: SideBarMenu[] = [];

	constructor() {}

	ngOnInit(): void {
		this.renderMenu(this.sideBarMenus);
	}

	renderMenu(sideBarMenus: SideBarMenu[]) {
		this.finalMenu = sideBarMenus.map((sideBarMenu) => {
			return this.setOpacity(sideBarMenu, 0);
		});
	}

	setOpacity(sideBarMenu: SideBarMenu, opacity: number) {
		sideBarMenu.opacity = opacity;
		if (sideBarMenu.subMenu) {
			sideBarMenu.subMenu = sideBarMenu.subMenu.map((sideBarMenu) => {
				return this.setOpacity(sideBarMenu, opacity + 1);
			});
		}
		return sideBarMenu;
	}

	onClickItem(item: any) {
		this.itemInSide.emit(item);
	}
}
